import arrayBufferToBase64 from './arrayBufferToBase64';
import importRsaKey from './importRsaKey';

export default async function encrypt(text: string): Promise<string> {
  const key = await importRsaKey(import.meta.env.VITE_PUBLIC_KEY);

  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(text));

  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: 'RSA-OAEP',
    },
    key,
    data
  );

  return arrayBufferToBase64(encrypted);
}
